import useQueryParams from './useQueryParams'

export default function useMetasearchPriceId(): string | undefined {
  const query = useQueryParams()

  return query.get('gpid') ?? undefined
}
